import tzlookup from "tz-lookup";

import { resolveTimezoneFromLocation } from "../utils/timezoneUtils";
import useLocationFromCache from "./useLocationFromCache";

export const useTimeZoneFromLocationId = (locationId: string) => {
  const { getCachedLocation } = useLocationFromCache();
  const location = getCachedLocation(locationId);

  return resolveTimezoneFromLocation(location) ?? tzlookup(0, 0);
};
